import React, { useState } from "react";
import { Phone, X, Map, MapPin } from "lucide-react";
import styles from "./OurCenter.module.css";

const centresData = [
  {
    city: "Drishti IAS Delhi",
    address: "Counselling Office: 641, Mukherjee Nagar, Delhi - 110009",
    mapUrl: "https://maps.google.com/maps?q=Drishti+IAS+641+Mukherjee+Nagar+Delhi+110009",
    image: "/images/Dashboard/delhibranch.png",
    phone: "+91 8750187501",
  },
  {
    city: "Drishti IAS Karol Bagh",
    address: "21, Pusa Road, Karol Bagh, Delhi - 110005",
    mapUrl: "https://maps.google.com/maps?q=Drishti+IAS+21+Pusa+Road+Karol+Bagh+Delhi+110005",
    image: "/images/Dashboard/karolbaghbranch.png",
    phone: "+91 8750187501",
  },
  {
    city: "Drishti IAS Noida",
    address: "C-171/2, Block A, Sector-15, Noida, UP- 201301",
    mapUrl: "https://maps.app.goo.gl/jLX4KYbNVmLbh5bh7",
    image: "/images/Dashboard/Drishti_IAS_Noida.png",
    phone: "+91 8750187501",
  },
  {
    city: "Drishti IAS Lucknow",
    address: "Burlington Chauraha, Vidhan Sabha Marg, Lucknow, UP - 226001",
    mapUrl: "https://maps.google.com/maps?q=Drishti+IAS+Burlington+Chauraha+Vidhan+Sabha+Marg+Lucknow+UP+226001",
    image: "/images/Dashboard/lucknowbrnach.png",
    phone: "+91 8750187501",
  },
  {
    city: "Drishti IAS Prayagraj",
    address: "Tashkent Marg, Civil Lines, Prayagraj, UP - 211001",
    mapUrl: "https://maps.google.com/maps?q=Drishti+IAS+Tashkent+Marg+Civil+Lines+Prayagraj+UP+211001",
    image: "/images/Dashboard/prayagrajbranch.png",
    phone: "+91 8750187501",
  },
  {
    city: "Drishti IAS Indore",
    address: "219, 2nd Floor, Veda Business Park, Bhanwarkua Main Rd, Indore, MP - 452001",
    mapUrl: "https://maps.google.com/maps?q=Drishti+IAS+219+Veda+Business+Park+Bhanwarkua+Main+Road+Indore+MP+452001",
    image: "/images/Dashboard/indorebranch.png",
    phone: "+91 8750187501",
  },
  {
    city: "Drishti IAS Jaipur",
    address: "Harsh Tower 2, Tank Road, Jaipur, Rajasthan - 302015",
    mapUrl: "https://maps.google.com/maps?q=Drishti+IAS+Harsh+Tower+2+Tank+Road+Jaipur+Rajasthan+302015",
    image: "/images/Dashboard/jaipurbranch.png",
    phone: "+91 8750187501",
  },
  
];

const FloatingDialer = ({ isOpen, onClose, selectedCenter }) => {
  if (!isOpen || !selectedCenter) return null;

  const handleLocationClick = () => {
    window.open(selectedCenter.mapUrl, "_blank");
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center animate-in fade-in duration-300">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full mx-4 shadow-2xl">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold text-[#4169E1]">{selectedCenter.city}</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-4">
          <div className="flex items-start gap-2 text-gray-600">
            <MapPin className="w-4 h-4 mt-1" />
            <p>{selectedCenter.address}</p>
          </div>

          <div className="flex flex-col gap-3">
            <a
              href={`tel:${selectedCenter.phone}`}
              className="bg-[#4267B2] text-white w-full py-4 rounded-xl flex items-center justify-center gap-3 transition-all hover:scale-[1.02] active:scale-[0.98]"
            >
              <Phone className="w-5 h-5" />
              <span className="font-medium">{selectedCenter.phone}</span>
            </a>

            <button
              onClick={handleLocationClick}
              className="bg-[#34A853] text-white w-full py-4 rounded-xl flex items-center justify-center gap-3 transition-all hover:scale-[1.02] active:scale-[0.98]"
            >
              <Map className="w-5 h-5" />
              <span className="font-medium">View on Maps</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const CentreCard = ({ city, address, image, phone, mapUrl, onSelect }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 w-[320px] relative overflow-hidden group cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onSelect({ city, address, phone, mapUrl })}
      style={{
        border: "1px solid #4267B2",
        padding: "10px",
      }}
    >
      <img src={image} alt={city} className="w-full h-[150px] object-cover rounded-t-lg transition-transform duration-300 group-hover:scale-105" />

      <div className="p-3">
        <h3 className="text-[#4267B2] text-lg font-semibold mb-1">{city}</h3>
        <div className="flex items-start gap-2 text-gray-800 text-xs">
          <MapPin className="w-4 h-4 mt-[2px]" />
          <p>{address}</p>
        </div>
      </div>

      <div
        className={`absolute inset-0 bg-gradient-to-t from-[#242424]/90 to-transparent 
          transition-all duration-300 flex flex-col justify-end items-center pb-4 gap-2
          ${isHovered ? "opacity-100" : "opacity-0"} pointer-events-none`}
      >
        <div className="pointer-events-auto flex flex-row gap-2">
          <div className="bg-white text-[#4169E1] px-4 py-2 rounded-full flex items-center gap-2 hover:scale-105 hover:shadow-lg transition-all">
            <Phone className="w-4 h-4" />
            <span className="font-medium">Call Now</span>
          </div>
          <div className="bg-white text-[#4169E1] px-4 py-2 rounded-full flex items-center gap-2 hover:scale-105 hover:shadow-lg transition-all">
            <MapPin className="w-4 h-4" />
            <span className="font-medium">Location</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const ConnectorLine = ({ direction = "right", width = 0 }) => (
  <div
    className={`absolute top-1/2 ${direction === "right" ? "right-[0px]" : "left-[0px]"} 
      transform -translate-y-1/2 flex items-center`}
    style={{ width: `${width}px` }}
  >
    <div className="relative w-full">
      <div
        className="absolute w-full h-[0px]"
        style={{
          background: "repeating-linear-gradient(to right, #4169E1 0, #4169E1 4px, transparent 4px, transparent 8px)",
        }}
      />
      <div
        className="absolute w-full h-[0px] top-[0px]"
        style={{
          background: "repeating-linear-gradient(to right, rgba(65, 105, 225, 0.1) 0, rgba(65, 105, 225, 0.1) 4px, transparent 4px, transparent 8px)",
        }}
      />
    </div>
  </div>
);

export default function OurCentres() {
  const [selectedCenter, setSelectedCenter] = useState(null);

  return (
    <div className="bg-gray-0 py-16 bg-gradient-to-br from-blue-50">
      <div className="container mx-auto px-8 max-w-[1200px]">
        <div className={`${styles.container} text-center mb-10`}>
          <h2 className="text-3xl font-bold mb-3">
            <span className="text-[#4267B2]">Our </span>Centres
          </h2>
          <p className="text-gray-600 mb-3">Pioneering Excellence in Offline Learning</p>
          <div className={styles.dividerContainer}>
            <hr className={styles.dividerLine} />
            <span className={styles.dividerText}>Locate your Nearest Drishti Centre</span>
            <br />
            <span className={styles.dividerText}>Serving Seven Major Cities</span>
            <hr className={styles.dividerLine} />
          </div>
        </div>
        <br />
        {/* Desktop layout */}
        <div className="hidden lg:block relative">
          <br />
          <br />
          <div className="flex justify-center items-center">
            <div className="absolute left-0 flex flex-col" style={{ gap: "15px" }}>
              <div className="relative">
                <CentreCard {...centresData[0]} onSelect={setSelectedCenter} />
                <ConnectorLine direction="right" width={55} />
              </div>
              <div className="relative ml-[35px]">
                <CentreCard {...centresData[1]} onSelect={setSelectedCenter} />
                <ConnectorLine direction="right" width={15} />
              </div>
              <div className="relative">
                <CentreCard {...centresData[2]} onSelect={setSelectedCenter} />
                <ConnectorLine direction="right" width={55} />
              </div>
            </div>

            <div className="relative w-[720px] mx-auto">
              <img src="/images/Dashboard/Map_New_noida.png" alt="India Map" className="w-full" />
              <div className="absolute inset-0 bg-[#FFF] opacity-30 mix-blend-multiply"></div>
            </div>

            <div className="absolute right-0 flex flex-col" style={{ gap: "15px" }}>
              <div className="relative">
                <ConnectorLine direction="left" width={25} />
                <CentreCard {...centresData[3]} onSelect={setSelectedCenter} />
              </div>
              <div className="relative ml-[240px]">
                <ConnectorLine direction="left" width={20} />
                <CentreCard {...centresData[4]} onSelect={setSelectedCenter} />
              </div>
              <div className="relative">
                <ConnectorLine direction="left" width={20} />
                <CentreCard {...centresData[5]} onSelect={setSelectedCenter} />
              </div>
            </div>
          </div>

          {/* Extra centres below map Noida Added by Satyam */}
          <div className="mt-12 flex flex-wrap justify-center gap-6 ml-[-225px] mt-[-25px]">
            {centresData.slice(6).map((centre, index) => (
              <CentreCard key={`extra-${index}`} {...centre} onSelect={setSelectedCenter} />
            ))}
          </div>
        </div>

        {/* Mobile layout */}
        <div className="lg:hidden">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 justify-items-center">
            {centresData.map((centre, index) => (
              <CentreCard key={`mobile-${index}`} {...centre} onSelect={setSelectedCenter} />
            ))}
          </div>
        </div>

        <FloatingDialer isOpen={!!selectedCenter} onClose={() => setSelectedCenter(null)} selectedCenter={selectedCenter} />
      </div>
    </div>
  );
}
